import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import { tcasQuery } from '../../GraphQL/query/TCASSpec.query';

import ExamRequires from './ExamRequires';

export default class ExamRequiresQuery extends Component {
  static propTypes = {
    tcasId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };

  render() {
    const { tcasId } = this.props;
    return (
      <Query
        query={tcasQuery}
        variables={{
          tcasId,
        }}
      >
        {({ loading, error, data }) => {
          if (loading) return <div>Loading</div>;
          if (error) return <div>{JSON.stringify(error)}</div>;
          const { admissionRound } = data;
          return (
            <ExamRequires
              {...this.props}
              title={admissionRound.displayName}
              subTitle={admissionRound.seatsDisplayText}
              exams={admissionRound.requiredExams}
              examsSpec={(admissionRound && admissionRound.requiredExamsSpec) || {}}
            />
          );
        }}
      </Query>
    );
  }
}
